/** CRM-4 AccountSecurityPage — sessioni device + OTP info */
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Loader2, ShieldCheck, LogOut, Smartphone } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AccountSecurityPage() {
  const [me, setMe] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [m, s] = await Promise.all([
        axios.get(`${API}/api/admin/users/me`, { withCredentials: true }),
        axios.get(`${API}/api/admin/users/me/sessions`, { withCredentials: true }),
      ]);
      setMe(m.data); setSessions(s.data.items || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const revoke = async (id) => {
    if (!confirm("Revocare questa sessione?")) return;
    await axios.post(`${API}/api/admin/users/me/sessions/${id}/revoke`, {}, { withCredentials: true });
    load();
  };
  const revokeAll = async () => {
    if (!confirm("Revocare TUTTE le altre sessioni (tutti gli altri device)?")) return;
    await axios.post(`${API}/api/admin/users/me/sessions/revoke-all`, {}, { withCredentials: true });
    load();
  };

  if (loading) return <Loader2 className="w-5 h-5 animate-spin mx-auto" />;

  return (
    <div className="p-4 md:p-6 space-y-4" data-testid="account-security-page">
      <h2 className="text-xl font-semibold flex items-center gap-2"><ShieldCheck className="w-5 h-5" /> Sicurezza Account</h2>
      {me && (
        <div className="bg-white border border-zinc-200 rounded p-3 text-sm">
          <p><strong>{me.email}</strong> · ruolo <span className="text-emerald-700">{me.role}</span></p>
          <p className="text-xs text-zinc-500">2FA TOTP: {me.totp_enabled ? "✓ attivo" : "non attivo"} · OTP via email per nuovi device</p>
        </div>
      )}
      <div className="flex justify-between items-center">
        <h3 className="text-sm font-semibold">Sessioni attive ({sessions.length})</h3>
        <button onClick={revokeAll} className="px-2 py-1 text-xs bg-rose-50 text-rose-700 rounded" data-testid="revoke-all-btn">
          Revoca altri device
        </button>
      </div>
      <div className="space-y-2">
        {sessions.length === 0 ? <p className="text-zinc-400 italic text-xs">Nessuna sessione registrata</p> :
         sessions.map((s) => (
          <div key={s.id} className="border border-zinc-200 rounded p-3 flex justify-between items-center" data-testid={`session-${s.id}`}>
            <div>
              <p className="text-sm flex items-center gap-1"><Smartphone className="w-3 h-3" /> {s.is_new_device ? "Nuovo device" : "Trusted"}</p>
              <p className="text-xs text-zinc-500 truncate max-w-md">{s.user_agent} · IP {s.ip_address}</p>
              <p className="text-[10px] text-zinc-400">Ultima attività: {s.last_activity_at?.slice(0, 16).replace("T", " ")}</p>
            </div>
            <button onClick={() => revoke(s.id)} className="p-1.5 hover:bg-zinc-100 rounded text-rose-600" data-testid={`revoke-${s.id}`}>
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
      <p className="text-xs text-zinc-400 italic">
        I nuovi device richiedono verifica via OTP email (TTL 5min). Una volta verificati, vengono marcati trusted automaticamente.
      </p>
    </div>
  );
}
